import axios from 'axios'
import { Message, MessageBox, Loading } from 'element-ui'
import store from '@/store'
import API_CONFIG from '../../vue.config'
var loadinginstace

const company = '/company'
const OPM = '/OPM'

export const request = axios.create({
  baseURL: API_CONFIG.devServer.proxy[company].target + API_CONFIG.devServer.proxy[company].pathRewrite['/api'],
  timeout: 5000 // 定义5秒超时
  //
})

request.interceptors.request.use(
  config => {
    // loading
    loadinginstace = Loading.service({
      fullscreen: true,
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })


    if (config.method == 'post') {
      config.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
    } else if (config.method == 'get') {
      config.headers.get['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8'
    }

    if (store.getters.token) {

      config.headers['token'] = store.getters.token

    }
    return config
  },
  error => {
    loadinginstace.close()
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  response => {
    loadinginstace.close()
    // axios默认加了一层data
    const { code, msg, data } = response.data

    sessionStorage.setItem('requestCode', code)
    if (code === 0) {
      sessionStorage.setItem('successTip', msg)
      return data
    } else if (code === 1003) {
      MessageBox.alert(msg, '', {
        confirmButtonText: '确定',
        center: true,
        callback: () => {
          if (msg === '异常：您还没有登录或登录已超时!') {
            store.dispatch('user/logout') // 登出action 删除token
            // this.$router.push('/login')
          }
        }
      })
    } else {

      Message({
        showClose: true,
        message: msg,
        type: 'error'
      }) // 提示错误消息
      return Promise.reject(new Error(msg))
    }
    // return response
  },
  error => {
    loadinginstace.close()

    return Promise.reject(error) // 返回执行错误 让当前的执行链跳出成功 直接进入 catch
  }
)

export const service = axios.create({
  baseURL: API_CONFIG.devServer.proxy[OPM].target + API_CONFIG.devServer.proxy[OPM].pathRewrite['/api'],
  timeout: 5000 // 定义5秒超时
  //
})

// service.interceptors.request.use(
//   config => {
//     // loading
//     loadinginstace = Loading.service({
//       fullscreen: true,
//       lock: true,
//       text: 'Loading',
//       spinner: 'el-icon-loading',
//       background: 'rgba(0, 0, 0, 0.7)'
//     })


//     if (config.method == 'post') {
//       config.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
//     } else if (config.method == 'get') {
//       config.headers.get['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8'
//     }

//     if (store.getters.token) {

//       config.headers['token'] = store.getters.token

//     }
//     return config
//   },
//   error => {
//     loadinginstace.close()
//     return Promise.reject(error)
//   }
// )

// 响应拦截器
// service.interceptors.response.use(
//   response => {
//     loadinginstace.close()
//     // axios默认加了一层data
//     const { code, msg, data } = response.data

//     sessionStorage.setItem('requestCode', code)
//     if (code === 0) {
//       sessionStorage.setItem('successTip', msg)
//       return data
//     } else if (code === 1003) {
//       MessageBox.alert(msg, '', {
//         confirmButtonText: '确定',
//         center: true,
//         callback: () => {
//           if (msg === '异常：您还没有登录或登录已超时!') {
//             store.dispatch('user/logout') // 登出action 删除token
//             // this.$router.push('/login')
//           }
//         }
//       })
//     } else {

//       Message({
//         showClose: true,
//         message: msg,
//         type: 'error'
//       }) // 提示错误消息
//       return Promise.reject(new Error(msg))
//     }
//     // return response
//   },
//   error => {
//     loadinginstace.close()

//     return Promise.reject(error) // 返回执行错误 让当前的执行链跳出成功 直接进入 catch
//   }
// )


// export const loadinginstacec = () => {
//   // return loadinginstace
// }
// 是否超时
// 超时逻辑  (当前时间  - 缓存中的时间) 是否大于 时间差
// function IsCheckTimeOut() {
//   // 当前时间戳
//   var currentTime = Date.now()
//   // 缓存时间戳
//   var timeStamp = getTimeStamp()
//   return (currentTime - timeStamp) / 1000 > TimeOut
// }

// export default service
